import { useTranslation } from 'react-i18next';
import { Form } from '@anytag/shared-atoms';
import { ToggleOption } from '@anytag/shared-types';
import { RadiosField, RadiosFieldProps } from '@anytag/shared-molecules';
import { MarketplaceFormKeys } from '../types';

type ApproveInfluencersFieldProps = Pick<RadiosFieldProps, 'className' | 'disabled' | 'required'>;
export const ApproveInfluencersField = ({ className, required, disabled }: ApproveInfluencersFieldProps) => {
  const { t } = useTranslation();

  const options = [
    {
      value: ToggleOption.TRUE,
      label: t('Auto-approve applicant influencers'),
      help: t('Tooltip.Auto-approve applicant influencers')
    },
    {
      value: ToggleOption.FALSE,
      label: t('Manual-approve applicant influencers'),
      help: t('Tooltip.Manual-approve applicant influencers')
    }
  ];

  return (
    <Form.Field className={className}>
      <p className="mb-4 text-base font-semibold">{t('Choose how to approve influencers')}</p>
      <RadiosField
        itemsPerRow={2}
        options={options}
        required={required}
        disabled={disabled}
        className="p-0 text-base"
        name={MarketplaceFormKeys.isAutoInfluencerApproval}
      />
    </Form.Field>
  );
};
